<div *ngIf="annualStatementLoaded">
  <div *ngIf="showAnnualStatementComaprisonInfo" class="heading-row-line"> <a (click)="navigateToAnnualStatementComparison()" class="view-more-link">
      Click Here
    </a> to view Annual Statement Comparison Report</div>
  <div class="total-row">
    <table class="table">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Category</th>
          <th scope="col">Direct</th>
          <th scope="col">Reinsurance From Non-Affiliates</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of annualStatement; let row = index">
          <ng-container *ngIf="is_aggwn_label(item.Text); else defaultview">
            <template *ngTemplateOutlet="defaultview"></template>
            <tr>
              <td>
                {{ item.DisplayText }}
              </td>
              <td>
                ISO Line To Apply Aggregate Write-In
              </td>
              <td>
                {{ isoline || '-' }}
              </td>
              <td></td>
            </tr>
          </ng-container>
          <ng-template #defaultview>
            <tr>
              <td>
                {{ item.DisplayText }}
              </td>

              <td>
                {{ item.Text }}
              </td>
              <td>
                {{ item.Col1 | number:'1.0-0' }}
              </td>
              <td>
                {{ item.Col2 | number:'1.0-0' }}
              </td>
            </tr>
          </ng-template>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>